export default __webpack_public_path__ + "static/media/icon-animal friendly.ba15e067.svg";